export async function startConversationWithUnion(supabase, workerId, unionId, apprenticeshipId, currentUserType = 'worker') {
  const { data: existingRows } = await supabase
    .from('conversations')
    .select('id, worker_hidden_at, union_hidden_at')
    .eq('worker_id', workerId)
    .eq('union_id', unionId)
    .order('created_at', { ascending: false });

  const existing = (existingRows || []).find(row => {
    const hiddenByCurrentUser = currentUserType === 'union' ? row.union_hidden_at : row.worker_hidden_at;
    return !hiddenByCurrentUser;
  });

  if (existing) return existing.id;

  const { data: created, error } = await supabase
    .from('conversations')
    .insert({
      worker_id: workerId,
      union_id: unionId,
      conversation_type: 'worker_union'
    })
    .select('id')
    .single();

  if (error) {
    console.error('[startConversationWithUnion] Insert error:', error);
    return null;
  }

  return created?.id || null;
}
